var _g, _g2, _rect, _rect2, _g3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicCustomizationFeature03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 169,
    viewBox: "0 0 275 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2033_20840)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.4609,
    width: 202.076,
    height: 150.098,
    rx: 4,
    fill: "url(#paint0_linear_2033_20840)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2033_20840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.579 16.9722H96.9232C93.5546 16.9722 90.8238 14.2414 90.8238 10.8728V10.0772C90.8238 6.56217 87.9743 3.71265 84.4592 3.71265H49.1888C45.6737 3.71265 42.8242 6.56217 42.8242 10.0772V10.8728V13.7899C42.8242 15.5474 41.3995 16.9722 39.6419 16.9722C38.7632 16.9722 38.0508 17.6846 38.0508 18.5633V141.355C38.0508 144.867 40.8951 147.715 44.4069 147.72L230.571 147.968C234.089 147.973 236.944 145.122 236.944 141.603V23.3368C236.944 19.8217 234.094 16.9722 230.579 16.9722Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 5.83423,
    width: 43.4927,
    height: 8.48637,
    rx: 4.24319,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.6055,
    y: 8.48608,
    width: 3.18239,
    height: 3.18239,
    rx: 1.5912,
    fill: "#EAEAEA"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2033_20840)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.0039,
    y: 145.325,
    width: 252.992,
    height: 10.0773,
    rx: 4.24306,
    fill: "#111111"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 64.7065,
    width: 53.5702,
    height: 10.608,
    rx: 5.30398,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 102.364,
    width: 53.5702,
    height: 10.608,
    rx: 5.30398,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 78.4965,
    width: 53.5702,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 84.3307,
    width: 77.4358,
    height: 3.71267,
    rx: 1.85634,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 90.165,
    width: 36.5975,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 27.0494,
    width: 53.5702,
    height: 10.608,
    rx: 5.30398,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 40.8397,
    width: 53.5702,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 46.674,
    width: 77.4358,
    height: 3.71267,
    rx: 1.85634,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 52.5082,
    width: 36.5975,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 116.154,
    width: 53.5702,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 121.988,
    width: 77.4358,
    height: 3.71267,
    rx: 1.85634,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9492,
    y: 127.822,
    width: 36.5975,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 136.707,
    y: 16.4418,
    width: 100.242,
    height: 128.883,
    fill: "#0F0F26"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 27.0494,
    width: 53.5702,
    height: 10.608,
    rx: 5.30398,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 64.7065,
    width: 53.5702,
    height: 10.608,
    rx: 5.30398,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 102.364,
    width: 53.5702,
    height: 10.608,
    rx: 5.30398,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 78.4965,
    width: 53.5702,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 84.3307,
    width: 77.4358,
    height: 3.71267,
    rx: 1.85634,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 90.1649,
    width: 36.5975,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 40.8394,
    width: 53.5702,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 46.6736,
    width: 77.4358,
    height: 3.71267,
    rx: 1.85634,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 52.5077,
    width: 36.5975,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 116.154,
    width: 53.5702,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 121.988,
    width: 77.4358,
    height: 3.71267,
    rx: 1.85634,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 148.371,
    y: 127.822,
    width: 36.5975,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2033_20840)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.188,
    y: 55,
    width: 51.237,
    height: 51.237,
    rx: 6.40443,
    fill: "#0A0A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.419 81.4613C200.251 83.2783 199.569 85.0099 198.453 86.4535C197.337 87.8971 195.833 88.9929 194.117 89.6129C192.401 90.2328 190.543 90.3511 188.762 89.954C186.981 89.5568 185.35 88.6607 184.06 87.3704C182.77 86.0801 181.873 84.4491 181.476 82.6681C181.079 80.8871 181.198 79.0298 181.817 77.3136C182.437 75.5974 183.533 74.0932 184.977 72.9771C186.42 71.8609 188.152 71.179 189.969 71.0111C188.905 72.4503 188.393 74.2235 188.526 76.0082C188.659 77.7929 189.429 79.4706 190.694 80.7361C191.96 82.0016 193.637 82.7708 195.422 82.9039C197.207 83.037 198.98 82.5251 200.419 81.4613Z",
    stroke: "white",
    strokeWidth: 2.13481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2033_20840)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.3359,
    y: 55.1043,
    width: 44.6639,
    height: 44.6639,
    rx: 5.58281,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2033_20840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6642 82.088C86.2337 82.088 88.3167 80.005 88.3167 77.4355C88.3167 74.866 86.2337 72.783 83.6642 72.783C81.0947 72.783 79.0117 74.866 79.0117 77.4355C79.0117 80.005 81.0947 82.088 83.6642 82.088Z",
    stroke: "black",
    strokeWidth: 1.86094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6562 67.2005V69.0615",
    stroke: "black",
    strokeWidth: 1.86094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6562 85.8099V87.6709",
    stroke: "black",
    strokeWidth: 1.86094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4258 70.1965L77.7471 71.5178",
    stroke: "black",
    strokeWidth: 1.86094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5781 83.3533L90.8994 84.6746",
    stroke: "black",
    strokeWidth: 1.86094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4258 77.4354H75.2868",
    stroke: "black",
    strokeWidth: 1.86094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0391 77.4354H93.9001",
    stroke: "black",
    strokeWidth: 1.86094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4258 84.6746L77.7471 83.3533",
    stroke: "black",
    strokeWidth: 1.86094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5781 71.5178L90.8994 70.1965",
    stroke: "black",
    strokeWidth: 1.86094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2033_20840",
    x: 34.3394,
    y: -2.12153,
    width: 206.317,
    height: 154.341,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.06076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2033_20840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2033_20840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2033_20840",
    x: 35.9293,
    y: 1.59112,
    width: 203.138,
    height: 148.498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.06076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2033_20840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2033_20840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2033_20840",
    x: 0.396267,
    y: 136.838,
    width: 274.207,
    height: 31.2925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.30382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2033_20840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2033_20840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2033_20840",
    x: 149.176,
    y: 42.1911,
    width: 83.2604,
    height: 83.2591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.20221
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.00553
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2033_20840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2033_20840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2033_20840",
    x: 47.3789,
    y: 43.9387,
    width: 72.5781,
    height: 72.5779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.79141
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.97852
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2033_20840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2033_20840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2033_20840",
    x1: 137.499,
    y1: 0,
    x2: 137.499,
    y2: 150.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2033_20840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3319,
    height: 22.3319,
    fill: "white",
    transform: "translate(72.5 66.27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicCustomizationFeature03);
export default __webpack_public_path__ + "static/media/sonic-customization-feature-03.e4bed3dc0b34556f934a449dcecf984a.svg";
export { ForwardRef as ReactComponent };